<template>
  <div id="app">
    <b-container fluid class="hero">
      <Header/>
      <Navbar/>
    </b-container>
    <router-view :key="$route.fullPath" />
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    Header, Navbar, Footer
  }
}
</script>

<style>
  .hero {
    min-height: 450px;
    background-image: url('~@/assets/hero.jpg');
    background-size: cover;
    background-position: center center;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .select-blue .el-input__inner {
    background-color: #006fb9;
    color: #fff;
  }
  .select-blue .el-input__inner::placeholder, .select-grey .el-input__inner::placeholder {
    color: #fff;
  }
  .select-blue .el-input .el-select__caret, .select-grey .el-input .el-select__caret {
    color: white;
  }
  .select-grey .el-input__inner {
    background-color: #d5d5d5;
    color: #fff;
  }
  @media print {
    .modal-header {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue